// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__xcmlZ"};